/** 品牌 Logo（UI / favicon 同源） */
export const BRAND_LOGO = '/static/image/brand/logo.webp';

/** Joule 代币图标（全站唯一） */
export const JOULE_LOGO = '/static/image/joule_logo.webp';

/** Tabbar 中间 AI 入口 */
export const AI_FAB_LOGO = '/static/image/lanhu/tabbar/ai-fab.webp';
